export default __webpack_public_path__ + "static/media/Kick.a8730778.wav";